import React, { Fragment } from 'react';
import { string, node, oneOfType } from 'prop-types';
import variables from '../../styles/variables.module.scss';

const TitleDescription = ({
  title,
  description,
  children,
}) => (
  <Fragment>
    <h4
      style={{
        color: variables.springGreen,
        marginBottom: 16,
      }}
    >
      {title}
    </h4>
    <p style={{ color: variables.cleanWhite }}>
      {description}
    </p>
    {children && (
      <div>
        {React.cloneElement(children, {
          style: { color: variables.cleanWhite },
        })}
      </div>
    )}
  </Fragment>
);

TitleDescription.propTypes = {
  title: oneOfType([string, node]),
  description: oneOfType([string, node]),
  children: node,
};

TitleDescription.defaultProps = {
  title: null,
  description: null,
  children: null,
};

export default TitleDescription;
